import React from 'react'
import { OptionProp } from '../OptionSelector.constant'
import classnames from 'classnames'
import { Button, BUTTON_SIZE, BUTTON_TYPES } from '@src/quince-components/src'
import styles from './packOption.module.scss'

type PackOptionProps = {
  value: string
  quantityInPack?: number
} & Pick<OptionProp, 'isSelected' | 'salePrice' | 'className'>

const PackOption = ({ value, quantityInPack, isSelected, className, salePrice }: PackOptionProps) => {
  return (
    <Button
      children={renderButtonValue(value, salePrice, quantityInPack)}
      type={BUTTON_TYPES.OUTLINED}
      size={BUTTON_SIZE.MEDIUM}
      disabled={false}
      round={false}
      className={classnames(styles.option, isSelected && styles.selected_option)}
    />
  )
}

const renderButtonValue = (value: string, salePrice: number | undefined, quantityInPack?: number) => {
  const salePriceValue = salePrice && (Math.round(salePrice * 100) / 100).toFixed(2)
  const priceForEachItem = salePriceValue && quantityInPack && (parseFloat(salePriceValue) / quantityInPack).toFixed(2)

  return (
    <>
      <span>
        {value} {salePriceValue && `$${salePriceValue}`}
      </span>
      {priceForEachItem && <span className={styles.itemPrice}>{` ($${priceForEachItem} ea.)`}</span>}
    </>
  )
}

export default PackOption
